
import { createTheme } from "@mui/material/styles";

export const getTheme = (mode) =>
  createTheme({
    direction: "rtl",
    palette: {
      mode: mode,
      primary: {
        main: "#ff85b3",
      },
      secondary: {
        main: "#28a745",
      },
      background: {
        default: mode === "dark" ? "#181818" : "#f4f4f4",
        paper: mode === "dark" ? "#1e1e1e" : "#ffffff",
      },
      text: {
        primary: mode === "dark" ? "#ffffff" : "#000000",
        secondary: mode === "dark" ? "#b0b0b0" : "#333333",
      },
    },
    typography: {
      fontFamily: `"Tajawal", "Roboto", "Arial", sans-serif`,
      h4: {
        fontWeight: "bold",
      },
      body1: {
        fontSize: "16px",
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            scrollbarWidth: "thin",
            scrollbarColor: "#0d0d0d #3a3f4b",
          },
          "*::-webkit-scrollbar": {
            width: "8px",
          },
          "*::-webkit-scrollbar-track": {
            backgroundColor: "#3a3f4b",
            borderRadius: "10px",
          },
          "*::-webkit-scrollbar-thumb": {
            backgroundColor: "#0d0d0d",
            borderRadius: "10px",
            border: "2px solid #3a3f4b",
            backgroundClip: "padding-box",
          },
          "*::-webkit-scrollbar-button": {
            display: "none",
          },
        },
      },
    },
  });
